module.exports = __webpack_public_path__ + "img/hud-ring-inner.bcff1552.png";